var moment = require('moment');
var TorsoFormModel = require('backbone-torso/modules/FormModel');
// Hard coded year value since we're only validating MM/DD. This is, in fact, a leap year
var CONSTANT_YEAR_VALUE = '3004';

/**
 * FormModel for the EregAuthBarcodeSecurityQuestionFormView
 * @class EregAuthBarcodeSecurityQuestion
 * @constructor
 */
module.exports = TorsoFormModel.extend({
  validation: {
    month: {
      requiredField: true,
      msg: 'eregAuth.barcode.error.monthRequired'
    },
    day: [{
      requiredField: true,
      msg: 'eregAuth.barcode.error.dayRequired'
    }, {
      fn: function(day) {
        var month = this.get('month');
        var isValidDate = moment(CONSTANT_YEAR_VALUE + ' ' + month + ' ' + day, 'YYYY MMM DD').isValid();
        if (!isValidDate) {
          return 'eregAuth.barcode.error.invalidDay';
        }
      }
    }]
  }
});
